import { render, staticRenderFns } from "./PatientSearchbarComponent.vue?vue&type=template&id=1090bbdb"
import script from "./PatientSearchbarComponent.vue?vue&type=script&lang=js"
export * from "./PatientSearchbarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports